// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jW6y1QY38RT_eXB_XsID{stroke-width:1px;fill:rgba(150,150,180,.2)}`, "",{"version":3,"sources":["webpack://./src/js/browsers/Pulsar/components/Chromosomes/outline.module.scss"],"names":[],"mappings":"AAAA,sBACI,gBAAA,CACA,yBAAA","sourcesContent":[".armOutline {\n    stroke-width: 1px;\n    fill: rgba(150, 150, 180, 0.2);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"armOutline": `jW6y1QY38RT_eXB_XsID`
};
export default ___CSS_LOADER_EXPORT___;
